import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from "react-helmet";
import {
  NextProject,
  ProjectAwards,
  ProjectBannerImage,
  ProjectDescription,
  ProjectDownloads,
  ProjectImpacts,
  ProjectLinks,
  ProjectListTextImage,
  ProjectVideos,
} from '../atoms';
import BannerSlider from '../modules/BannerSlider/BannerSlider';

// Search this string (projectTraces) in translations
const pathProject = "projectTraces";

const ProjectTraces = () => {

  const { t, i18n } = useTranslation();

  useEffect(() => {
    const lng = localStorage.getItem("language");
    i18n.changeLanguage(lng);
  }, [i18n])

  return (
    <div className='projectLayout'>
      <Helmet>
        <title>Traces | Instituto E</title>
      </Helmet>
      <BannerSlider
        slides={
          [
            {
              image: "../../../images/projects/traces/1.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/traces/2.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/traces/3.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/traces/4.jpg",
              alt: "description alt image",
            },
            {
              image: "../../../images/projects/traces/5.jpg",
              alt: "description alt image",
            }
          ]}>
      </BannerSlider>

      {/* Possible to import all inside div with class: "projectLayoutContent", in the following order:
          - ProjectDescription
          - ProjectImpacts
          - ProjectAwards
          - ProjectLinks
          - ProjectVideos
          - ProjectDownloads
          - Outside the div: ProjectBannerImage
          - Outside the div: ProjectListTextImage */}

      <div className='projectLayoutContent'>
        <ProjectDescription
          title={`${t(`${pathProject}.title`)}`}
          subtitle={`${t(`${pathProject}.subtitle`)}`}
          paragraphs={[
            {
              type: "text",
              p: `${t(`${pathProject}.p1`)}`
            },
            {
              type: "text",
              p: `${t(`${pathProject}.p2`)}`
            }
          ]} />

        <ProjectVideos
          videos={[
            {
              linkYT: 'https://www.youtube.com/watch?v=CB8Jo9Mu6_c&t=60s&ab_channel=Instituto-e',
              textVideo: `${t(`${pathProject}.videoText1`)}`
            }
          ]} />

        <ProjectDownloads
          downloads={[
            {
              fileToDownload: "../../../pdf/Traces.pdf",
              textDownload: `${t(`${pathProject}.downloadText1`)}`
            }
          ]} />
      </div>

      <NextProject link="project-water-traces"></NextProject>

    </div>
  )
};

export default ProjectTraces;
